export enum GroupFilterEnum {
  MyTeams = "MY_TEAMS",
}
